import {
  approveRecurringFilePartialToInQueue,
  SuccessResponse,
  UpdateRecurringFileResponse,
} from '@back-office/http';
import { FlowReturn } from 'mobx-state-tree/dist/core/flow';
import {
  ResponseMessage,
  STATUS_CODE_NOT_AUTHORIZED,
  STATUS_CODE_SUCCESS,
} from '../../constants';
import { handleErrorVoidRefund, handleNotAuthorized, Self } from '../common';

function* approvedRecurringFilePartialRequest(
  self: Self,
  id: string[],
  requestedAt: string
): Generator<Promise<FlowReturn<SuccessResponse>>> {
  self.isLoading = true;
  try {
    const response = yield approveRecurringFilePartialToInQueue(
      id,
      requestedAt
    );
    const { status, data } = (response as UpdateRecurringFileResponse).data;

    if (status.code === STATUS_CODE_SUCCESS) {
      return data;
    }
    if (status.code === STATUS_CODE_NOT_AUTHORIZED) {
      handleNotAuthorized(self, response as SuccessResponse);
      return Promise.reject(status.code);
    }
    handleErrorVoidRefund(self);
    return Promise.reject(new Error(ResponseMessage.Error));
  } catch (e) {
    return Promise.resolve('Internal server error.');
  } finally {
    self.isLoading = false;
  }
}

export default approvedRecurringFilePartialRequest;
